import { render, staticRenderFns } from "./ImsTradersList.vue?vue&type=template&id=e67db662&"
import script from "./ImsTradersList.vue?vue&type=script&lang=js&"
export * from "./ImsTradersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports